import { render, staticRenderFns } from "./pointApplyCreate.vue?vue&type=template&id=04b9dac0&scoped=true&"
import script from "./pointApplyCreate.vue?vue&type=script&lang=js&"
export * from "./pointApplyCreate.vue?vue&type=script&lang=js&"
import style0 from "./pointApplyCreate.vue?vue&type=style&index=0&id=04b9dac0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9dac0",
  null
  
)

export default component.exports